var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{class:_vm.typeList[_vm.icon].icon}),_vm._v(" "+_vm._s(_vm.showDescription ? _vm.typeList[_vm.icon].description : "")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }